import { render } from "./jobs.vue?vue&type=template&id=596e37d0"
import script from "./jobs.vue?vue&type=script&lang=js"
export * from "./jobs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__